import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type UISliceState = {
  scrollHeights: { [key: string]: number }
  tabSelection: { [key: string]: string }
}

type UIActionPayload = {
  key: string
  value: number | string
}

const initialState: UISliceState = {
  scrollHeights: {},
  tabSelection: {}
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setScrollHeight: (state, action: PayloadAction<UIActionPayload>) => {
      state.scrollHeights[action.payload.key] = Number(action.payload.value)
    },
    setSelectedTab: (state, action: PayloadAction<UIActionPayload>) => {
      state.tabSelection[action.payload.key] = String(action.payload.value)
    }
  }
})

export const reducer = uiSlice.reducer

export const { setScrollHeight, setSelectedTab } = uiSlice.actions
